export const categories = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { name: "Hoodies / Sweaters", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
  { name: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  { name: "Pants / Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
  { name: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
  { name: "Sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html" },
  { name: "Underwear / Underpants", url: "https://kaspreadsheet.com/search-918/name/Shoes.html" },
  { name: "Jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html" },
  { name: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
  { name: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html" },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html" },
  { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Shoes.html" },
];

export const featuredCategories = [
  {
    name: "Shoes",
    desc: "Latest sneakers & footwear",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Close%20up%20of%20pristine%20white%20minimalist%20sneakers%20on%20natural%20stone%20surface%2C%20morning%20sunlight%20casting%20long%20soft%20shadows%2C%20simple%20clean%20product%20photography%2C%20warm%20neutral%20aesthetic%2C%20no%20text%2C%20no%20branding&width=600&height=600&seq=cat-v2-shoes&orientation=squarish",
  },
  {
    name: "Hoodies / Sweaters",
    desc: "Cozy styles for every season",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Cozy%20oversized%20oatmeal%20colored%20hoodie%20draped%20over%20wooden%20chair%2C%20warm%20afternoon%20light%20through%20sheer%20curtains%2C%20lifestyle%20product%20photography%2C%20soft%20textures%2C%20cream%20and%20beige%20tones%2C%20no%20text%2C%20no%20branding&width=600&height=600&seq=cat-v2-hoodies&orientation=squarish",
  },
  {
    name: "T-Shirts",
    desc: "Essential basics & graphics",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Crisp%20white%20cotton%20tshirt%20folded%20neatly%20on%20light%20oak%20wooden%20surface%2C%20natural%20daylight%2C%20minimalist%20fashion%20photography%2C%20clean%20aesthetic%2C%20no%20text%2C%20no%20branding&width=600&height=600&seq=cat-v2-tshirts&orientation=squarish",
  },
  {
    name: "Jackets",
    desc: "Outerwear from trusted sellers",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Vintage%20inspired%20olive%20green%20utility%20jacket%20hanging%20on%20wooden%20hanger%20against%20warm%20sand%20colored%20wall%2C%20soft%20directional%20light%2C%20editorial%20fashion%20photography%2C%20earthy%20tones%2C%20no%20text%2C%20no%20branding&width=600&height=600&seq=cat-v2-jackets&orientation=squarish",
  },
  {
    name: "Pants / Shorts",
    desc: "Bottoms from verified sellers",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Relaxed%20fit%20beige%20linen%20trousers%20laid%20flat%20on%20woven%20rattan%20surface%2C%20tropical%20natural%20light%2C%20resort%20wear%20photography%2C%20warm%20neutral%20palette%2C%20no%20text%2C%20no%20branding&width=600&height=600&seq=cat-v2-pants&orientation=squarish",
  },
  {
    name: "Bags",
    desc: "Totes, backpacks & more",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Structured%20tan%20leather%20tote%20bag%20standing%20on%20marble%20surface%2C%20soft%20studio%20lighting%2C%20luxury%20accessories%20photography%2C%20warm%20golden%20tones%2C%20clean%20composition%2C%20no%20text%2C%20no%20branding&width=600&height=600&seq=cat-v2-bags&orientation=squarish",
  },
  {
    name: "Accessories",
    desc: "Watches, jewelry & more",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Elegant%20minimal%20gold%20toned%20wristwatch%20with%20leather%20strap%20on%20smooth%20ceramic%20surface%2C%20soft%20diffused%20studio%20light%2C%20jewelry%20product%20photography%2C%20warm%20metallic%20highlights%2C%20no%20text%2C%20no%20branding&width=600&height=600&seq=cat-v2-accessories&orientation=squarish",
  },
  {
    name: "Jersey",
    desc: "Sports jerseys & athletic wear",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Athletic%20mesh%20jersey%20in%20muted%20sage%20green%20laid%20flat%20on%20light%20grey%20concrete%20texture%2C%20bright%20natural%20daylight%2C%20sportswear%20product%20photography%2C%20clean%20modern%20aesthetic%2C%20no%20text%2C%20no%20branding&width=600&height=600&seq=cat-v2-jersey&orientation=squarish",
  },
  {
    name: "Headwear",
    desc: "Caps, beanies & hats",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Soft%20unstructured%20beige%20canvas%20baseball%20cap%20on%20smooth%20terrazzo%20surface%2C%20morning%20light%20from%20side%2C%20accessories%20product%20photography%2C%20minimal%20composition%2C%20no%20text%2C%20no%20branding&width=600&height=600&seq=cat-v2-headwear&orientation=squarish",
  },
];

export const comparisonData = [
  { seller: "TopSneakerPlug", rating: "★★★★★ 4.9", price: "$$", shipping: "7-12 Days", category: "Sneakers" },
  { seller: "StyleHavenStore", rating: "★★★★☆ 4.8", price: "$", shipping: "10-15 Days", category: "Clothing" },
  { seller: "BagMasterPro", rating: "★★★★☆ 4.7", price: "$$$", shipping: "7-10 Days", category: "Bags" },
  { seller: "JerseyKing88", rating: "★★★★★ 4.9", price: "$$", shipping: "8-12 Days", category: "Jerseys" },
  { seller: "AccentFinds", rating: "★★★★☆ 4.6", price: "$", shipping: "12-18 Days", category: "Accessories" },
];

export const platformComparison = [
  { feature: "Spreadsheet Access", allchinabuy: "Comprehensive", others: "Limited / None" },
  { feature: "Product List Size", allchinabuy: "10,000+ Items", others: "Varies" },
  { feature: "Seller Ratings", allchinabuy: "Verified & Updated", others: "Partial / Outdated" },
  { feature: "Buying Guides", allchinabuy: "In-depth Tutorials", others: "Minimal" },
  { feature: "Safety Tips", allchinabuy: "QC & Shipping Advice", others: "Rarely Included" },
  { feature: "Category Navigation", allchinabuy: "14 Categories", others: "Basic Only" },
];

export const faqData = [
  {
    q: "What is an AllChinaBuy Spreadsheet?",
    a: "An AllChinaBuy Spreadsheet is a curated product list that helps buyers find verified items from trusted sellers on the AllChinaBuy platform. It includes categories like sneakers, clothing, bags, accessories, and more — with seller ratings, price comparisons, and direct links to make shopping safer and faster.",
  },
  {
    q: "How do I use the AllChinaBuy Spreadsheet?",
    a: "Simply browse the categories that match what you are looking for, check seller ratings and reviews, compare prices across different vendors, and click through to the product page on AllChinaBuy. The spreadsheet is organized to help you find exactly what you need without searching through thousands of unverified listings.",
  },
  {
    q: "Are the sellers in the AllChinaBuy Spreadsheet trusted?",
    a: "Yes. Every seller listed in our AllChinaBuy Spreadsheet has been vetted through buyer reviews, transaction history, and product quality checks. We regularly update seller ratings and remove any vendor that receives consistent negative feedback to keep the list reliable.",
  },
  {
    q: "Is the AllChinaBuy Spreadsheet free to use?",
    a: "Absolutely. The AllChinaBuy Spreadsheet is completely free to access and browse. There are no hidden fees or subscriptions required — just open the spreadsheet, find what you need, and click through to make your purchase on AllChinaBuy.",
  },
  {
    q: "How often is the AllChinaBuy Spreadsheet updated?",
    a: "We update the AllChinaBuy Spreadsheet daily with new products, seller ratings, price changes, and availability status. Our team monitors the market continuously to ensure the information you see is current and accurate for 2026.",
  },
  {
    q: "Can I request a specific product to be added?",
    a: "While we strive to cover all popular categories, we welcome suggestions. Our AllChinaBuy Spreadsheet already covers 14 categories including shoes, hoodies, t-shirts, jackets, pants, headwear, sets, underwear, jerseys, accessories, bags, belts, perfumes, and other stuff — so most products are already included.",
  },
];